import { useEffect, useState } from 'react';
import { mailboxAPI } from '../../lib/communicationsAPI';
import api from '../../lib/api';

const Pill = ({ tone, children, testId }) => (
  <span className={`rounded-full px-2 py-0.5 text-xs font-medium ${tone === 'ok' ? 'bg-success/15 text-success' : tone === 'warn' ? 'bg-warning/15 text-warning' : 'bg-muted text-muted-foreground'}`} data-testid={testId}>{children}</span>
);

// Honest summary of every integration; values come from the same endpoints the detailed cards below use.
export const IntegrationStatusCard = ({ xeroStatus, xpmStatus }) => {
  const [mail, setMail] = useState(null);
  const [ai, setAi] = useState(null);
  useEffect(() => {
    Promise.all([mailboxAPI.providers().catch(() => null), mailboxAPI.list().catch(() => null)]).then(([p, l]) => {
      const prov = p?.data?.providers || {};
      const list = Array.isArray(prov) ? prov : Object.entries(prov).map(([k, v]) => ({ provider: k, ...v }));
      const accounts = l?.data?.accounts || [];
      setMail(['google', 'm365'].map((k) => ({ k, configured: !!list.find((x) => x.provider === k || x.id === k)?.configured, connected: accounts.filter((a) => a.provider === k && a.status !== 'disconnected').length })));
    });
    api.get('/api/bas-ai/settings').then((r) => setAi(r.data)).catch(() => setAi(false));
  }, []);
  const mailRow = (k, label) => {
    const m = mail?.find((x) => x.k === k);
    return [label, !m ? '…' : m.connected ? `${m.connected} mailbox(es) connected` : m.configured ? 'Available, not connected' : 'Inactive', m?.connected ? 'ok' : m?.configured ? 'warn' : 'off', `int-${k}`];
  };
  const rows = [
    ['Xero', xeroStatus?.connected ? `Connected${xeroStatus.tenant_name ? ` · ${xeroStatus.tenant_name}` : ''}` : 'Not connected', xeroStatus?.connected ? 'ok' : 'off', 'int-xero'],
    ['Xero Practice Manager', xpmStatus?.connected ? 'Connected' : 'Not connected', xpmStatus?.connected ? 'ok' : 'off', 'int-xpm'],
    mailRow('google', 'Gmail'), mailRow('m365', 'Microsoft 365'),
    ['ATO / SBR lodgment', 'Not connected – lodgments are recorded manually', 'off', 'int-sbr'],
    ['Documenso e-signing', 'See the E-signature card below for connection status', 'off', 'int-documenso'],
    ['Claude (BAS suggestions)', ai === false ? 'Staff only' : !ai ? '…' : ai.platform_enabled && ai.key_configured ? (ai.enabled ? 'On for this practice' : 'Available, turned off') : 'Not available on this deployment', ai?.enabled && ai?.platform_enabled ? 'ok' : 'off', 'int-claude'],
  ];
  return (
    <div className="rounded-lg border border-border bg-card shadow-card" data-testid="integration-status-card">
      <div className="border-b border-border px-5 py-3"><h3 className="font-semibold">Integration status</h3><p className="text-xs text-muted-foreground">Live status. Nothing here is simulated.</p></div>
      <ul className="divide-y divide-border">{rows.map(([label, text, tone, tid]) => (
        <li key={tid} className="flex flex-wrap items-center gap-2 px-5 py-2.5 text-sm"><span className="min-w-[10rem] flex-1 font-medium">{label}</span><Pill tone={tone} testId={tid}>{text}</Pill></li>))}</ul>
    </div>
  );
};
